import React from 'react';
import './ResultCard.css';

const ResultCard = ({ image, title, titleBroadcast, link }) => (
  <div className="card">
    <a href={link} target='_blank' rel="noreferrer">
        <img src={image} alt={title} className="card-image"/>
        <div className="card-title-broadcast">{titleBroadcast}</div>
        <div className="card-title">{title}</div>
    </a>
  </div>
);

export default ResultCard;
